/* eslint-disable react-hooks/rules-of-hooks */
"use client";

import { FC } from "react";
import { useRouter } from "next/navigation";
import ArrowLeftIcon from "@/assets/icons/ArrowLeft.svg";
import CloseIcon from "@/assets/icons//closeSvg.svg";

import cn from "clsx";
import Styles from "./index.module.scss";

interface TitleBarProps {
  title?: string;
  toBack?: () => void;
  onClose?: () => void;
  children?: React.ReactNode;
  className?: string;
}
const TitleBar: FC<TitleBarProps> = (props) => {
  const toBack = () => {
    props.toBack && props.toBack();
  };
  const onClose = () => {
    props.onClose && props.onClose();
  };
  return (
    <div className={Styles.commonTitleBox}>
      <div className={cn(Styles.commonTitleWrap, props.className)}>
        {props.toBack && <ArrowLeftIcon className={Styles.backIcon} width={28} onClick={toBack} />}
        {props.onClose && <CloseIcon className={Styles.backIcon} width={28} onClick={onClose} />}
        {props.title && <div className={Styles.titleBox}>{props.title}</div>}
        {props.children}
      </div>
    </div>
  );
};

export default TitleBar;
